import { IconPencil } from '@tabler/icons-react';
import { EmployerDocumentDto } from '@zorro/clients';
import {
  DocumentCard,
  DocumentCardMenuItem,
} from '@zorro/design-system/v2/DocumentCard';
import { downloadEmployerDocument } from '@zorro/web/ui-utils';

import { buildDocumentCardDate } from '../DocumentListSection/documentCardUtils';

type Props = {
  document: EmployerDocumentDto;
  isEditable: boolean;
  onEdit?: (document: EmployerDocumentDto) => void;
  onDelete?: (document: EmployerDocumentDto) => void;
};

export const EmployerDocumentCard = ({
  document,
  isEditable,
  onEdit,
  onDelete,
}: Props) => {
  const menuItems: DocumentCardMenuItem[] | undefined =
    isEditable && onEdit
      ? [
          {
            label: 'Edit',
            icon: <IconPencil size={16} stroke={2} />,
            onClick: () => onEdit(document),
          },
        ]
      : undefined;

  return (
    <DocumentCard
      variant="border"
      fileName={document.fileName}
      description={document.description ?? undefined}
      date={buildDocumentCardDate(document.createdAt)}
      onDownload={() =>
        downloadEmployerDocument(document.documentUrl, document.fileName)
      }
      menuItems={menuItems}
      onDelete={isEditable && onDelete ? () => onDelete(document) : undefined}
    />
  );
};
